<template>
    <div
        class="split-text"
    >
        <div
            class="sizer"
            ref="sizer"
            v-html="data"
            v-if="!rendered"
        />
        <div
            class="renderer"
            ref="renderer"
            :key="i"
            v-for="(html, i) in unsafeHtml"
            v-html="html"
        />
    </div>
</template>
<script>
import WordParser from '@/pure/WordParser'
import { TweenMax } from 'gsap'
export default {
    props: {
        data: {
            type: String,
            default: ''
        },
        animated: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            rendered: false,
            unsafeHtml: []
        }
    },
    mounted() {
        if(this.$route.name === 'Legal' || this.$route.name === 'Termsofuse' || this.$route.name === 'Privacy' || this.$route.name === 'Credits' || window.innerWidth < 576) {
             this.unsafeHtml = [this.data]
        } else {
            this.setAnimated()
        }
        this.rendered = true
    },
    beforeDestroy()
    {
        window.removeEventListener('resize', this.handleResize)
        if(this._observer) this._observer.disconnect()
    },
    methods: {
        setAnimated() {
            if(this.$refs.sizer.children.length > 0) {
                [].forEach.call(this.$refs.sizer.children, (_, idx) => {
                    if(!!_.textContent || idx !== 0) {
                        const wordParser = new WordParser()
                        const words = wordParser.parseDOMtoText(_)
                        this.unsafeHtml.push(`<${_.tagName}>${words}</${_.tagName}>`)
                    }
                })
            } else {
                const wordParser = new WordParser()
                const words = wordParser.parseDOMtoText(this.$refs.sizer)
                this.unsafeHtml.push(`<p>${words}</p>`)

            }
            this.$nextTick(() => {
                this.handleResize()
                if(this.animated) {
                    TweenMax.set(this.$el.querySelectorAll('.caption'), {
                        y: '100%'
                    })
                    const options = {
                        rootMargin: '0px',
                        threshold: [0, 0.5]
                    }

                    this._observer = new IntersectionObserver(this.inOutScreen, options)
                    this._observer.observe(this.$el)
                }
            })
            window.addEventListener('resize', this.handleResize, window.captureEvent)
        },
        inOutScreen(entries) {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0.5) {
                    this.animate()
                }
            })
        },
        splitByLines(dom) {
            const lines = [].reduce.call(dom, (acc, word) => {
                const idx = parseInt(word.getAttribute('data-row'))
                if(!acc[idx]) {
                    acc[idx] = []
                }
                acc[idx].push(word.querySelectorAll('.caption'))
                return acc
            }, [])
            return lines
        },
        animate() {
            if(Array.isArray(this.$refs.renderer)) {
                let decals = 1
                this.$refs.renderer.forEach(renderer => {
                    const lines = this.splitByLines(renderer.querySelectorAll('.word'))

                    lines.forEach((line, i) => {
                        TweenMax.to(line, .625, {
                            y: '0%',
                            delay: .03 * decals * i + 0.0
                        })
                    })
                    decals ++
                })
            }
            this._observer.disconnect()
        },
        handleResize() {
            if(Array.isArray(this.$refs.renderer)) {
                [].forEach.call(this.$refs.renderer, renderer => this.parRenderer(renderer))
            }
        },
        parRenderer(renderer) {
            let y = -1
            let i = 0
            ;[].forEach.call(renderer.querySelectorAll('.word'), _ => {
                const caption  = _.querySelector('.caption')
                const deltaY = Math.floor(caption.offsetTop / caption.offsetHeight)
                if(y !== deltaY) {
                    y = deltaY
                    i++
                }
                _.setAttribute('data-row', i)
            })
        }
    }
}
</script>
<style lang="sass" scoped>
.sizer
    display: none
.renderer
    position: relative
    /deep/ h1,
    /deep/ h2,
    /deep/ h3,
    /deep/ h4,
    /deep/ h5,
    /deep/ p
        margin-right: -0.3em
        vertical-align: top
.split-text
    /deep/ .word
        // display: inline-flex
        .wrapper
            display: inline-flex
            overflow: hidden
            padding-right: .03em
        .caption
            display: block
            will-change: transform
            white-space: pre

</style>
